import * as Checkbox from "@radix-ui/react-checkbox";
import { styled } from "@vitality-ds/system";
import BaseCheckboxIndicatorStyles from "./styles/BaseCheckboxIndicator.styles";
import BaseCheckboxRootStyles from "./styles/BaseCheckboxRoot.styles";
export var BaseCheckboxRoot = styled(Checkbox.Root, BaseCheckboxRootStyles);
export var BaseCheckboxIndicator = styled(Checkbox.Indicator, BaseCheckboxIndicatorStyles);